import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ConnectedChildLinksComponent from "./connectedComponent";
import ExpandableList from "../ExpandableList";
import { getCategoryChildLinks } from "../../state/modules/category";

export const ExpandableChildLinks = ({ itemCount }) => (
  <ExpandableList
    itemCount={itemCount}
    ListComponent={ConnectedChildLinksComponent}
  />
);

ExpandableChildLinks.propTypes = {
  itemCount: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  itemCount: getCategoryChildLinks(state).length
});

export default connect(mapStateToProps)(ExpandableChildLinks);
